var UserSubResource = function() {
  var self = this;
  
  self.get = function(userSubId, options) {
    request.get($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId
    }, options));
  };

  self.add = function(username, options) {
    request.post($.extend(true, {
      url: '/api/user/current/user-subscriptions',
      data: {
        username: username
      }
    }, options));
  };
  
  self.update = function(userSubId, data, options) {
    request.post($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId,
      data: data
    }, options));
  };
  
  self.cancelSubscription = function(userSubId, data, options) {
    var params = {};
    if (data.reason) {
      params.reason = data.reason;
    }
    if (data.comment) {
      params.comment = data.comment;
    }
    var qs = $.param(params);
  
    request.delete($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId + '/subscription' + (qs ? '?' + qs : '')
    }, options));
  };

  self.removeSubscription = function(userSubId, options) {
    request.delete($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId
    }, options));
  };

  self.merge = function(data, options) {
    request.post($.extend(true, {
      url: '/api/user/current/user-subscriptions',
      data: data
    }, options));
  };

  self.executeMerge = function(token, options) {
    request.post($.extend(true, {
      url: '/api/user/current/user-subscriptions/execute',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }, options));
  };

  self.getAvailablePackages = function(userSubId, options) {
    request.get($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId + '/available-packages',
      data: {
        sort: 'price'
      }
    }, options));
  };

  self.getDiscountPackages = function(userSubId, options) {
    request.get($.extend(true, {
      url: '/api/user/current/user-subscription/' + userSubId + '/discount-packages',
      data: {
        sort: 'price'
      }
    }, options));
  };

  self.getMedia = function(userSubId, refresh, data, options) {
    request[refresh ? 'post' : 'get']($.extend({
      url: '/api/user/current/subscription/' + userSubId + '/media',
      data: data,
      timeout: 10 * 1000
    }, options));
  };

  self.sendLikes = function(userSubId, mediaId, data, options) {
    request.post($.extend(true, {
      url: '/api/user/current/subscription/' + userSubId + '/media/' + mediaId + '/send',
      data: data,
      timeout: 10 * 1000
    }, options));
  };
};

window.userSubResource = new UserSubResource();